export default __webpack_public_path__ + "static/image01-915d6c758132766e94719054d35e940b.jpg";